<template>
  <div>
    <HeaderInstaller
      :arrow="false"
      title="Aplicadores"
      text="Veja todos os aplicadores cadastrados, veja detalhes, desative aplicadores e edite seus cadastros."
      :haveAction="true"
      actionTitle="Novo Aplicador"
      @action1="addInstaller()"
      @action2="importExcel()"
      @action3="exportExcel()"
    />

    <v-tabs
      class="px-6 mb-0"
      style="margin-top: 20px !important"
      background-color="#ECEEF1"
      grow
      height="55"
      hide-slider
    >
      <v-tab
        @click="filterSolicita('all')"
        href="#mobile-tabs-5-1"
        active-class="active-tab"
        class="tab"
      >
        <span>Aplicadores</span>
      </v-tab>
      <v-tab
        active-class="active-tab"
        class="tab"
        @click="filterSolicita('Inativo')"
        href="#mobile-tabs-5-2"
      >
        <span>Solicitações</span>
        <span class="ma-3 px-3" style="color:red;max-width=350px">
          ({{ solicitations }} pedidos)
        </span>
      </v-tab>
    </v-tabs>

    <v-container style="max-width: unset" class="pa-5 pt-0 mb-0">
      <v-card
        transition="scale-transition"
        class="main-card pa-1 mt-0"
        v-if="showFilters"
        elevation="0"
      >
        <v-row class="ma-0 pa-0" align="center">
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              class="primary-input"
              v-model="filter.Email"
              v-on:keyup="filterTable"
              color="#F5F5F5"
              hide-details
              outlined
              placeholder="Nome ou e-mail do aplicador"
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26">
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="2" md="2">
            <v-autocomplete
              class="secondary-input"
              v-model="filter.Status"
              :items="status"
              item-text="name"
              color="#F5F5F5"
              item-value="value"
              hide-details
              outlined
              placeholder="Status"
              append-icon="mdi-chevron-down"
              @change="filterTable"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="2" md="2">
            <v-autocomplete
              class="secondary-input"
              v-model="filter.SpecialtiesId"
              :items="specialtiesArray"
              color="#F5F5F5"
              item-text="name"
              item-value="id"
              hide-details
              outlined
              placeholder="Especialidade"
              @change="filterTable"
              append-icon="mdi-chevron-down"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="2" md="2">
            <v-autocomplete
              class="secondary-input"
              v-model="filter.order"
              :items="orders"
              color="#F5F5F5"
              item-text="name"
              item-value="id"
              hide-details
              outlined
              placeholder="Ordem"
              @change="filterTable"
              append-icon="mdi-chevron-down"
            >
            </v-autocomplete>
          </v-col>

          <v-col class="d-flex justify-center justify-md-end">
            <v-btn
              outlined
              class="terciary-button"
              @click="reset"
              :loading="loading"
            >
              Limpar filtros
            </v-btn>
          </v-col>
        </v-row>

        <div class="d-flex justify-center my-2">
          <span class="actives">
            {{ countInstallers }} Aplicadores ativos
          </span>
        </div>
      </v-card>

      <!-- Tabela -->
      <v-data-table
        :loading="loading"
        loading-text="Carregando..."
        no-data-text="Nenhum aplicador encontrado"
        class="elevation-0 content-table"
        hide-default-footer
        :headers="headers"
        :items="installers"
        :items-per-page="pageSize"
        :header-props="headerProps"
        v-model="selectedInstallers"
        show-select
        item-key="id"
        :single-select="false"
      >
        <template v-slot:[`header.download`]="{ header }">
          <v-btn
            outlined
            tile
            icon
            v-on="header"
            class="quinary-button"
            style="border-radius: 5px"
            @click="exportExcel"
          >
            <v-icon>mdi-download-outline</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.created_at`]="{ item }">
          {{ formatDate(item.created_at) }}
        </template>

        <template v-slot:[`item.type`]="{ item }">
          {{
            item.type == 3
              ? "Aplicador"
              : item.type == 2
              ? "Revendedor"
              : "Outros"
          }}
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-select
            class="secondary-input ma-2"
            color="#F5F5F5"
            style="width: 120px!important; "
            hide-details
            dense
            outlined
            :items="status"
            @change="toggleChangeDialog(item)"
            item-text="name"
            item-value="value"
            v-model="item.status"
          >
          </v-select>
        </template>

        <template v-slot:[`item.recommendation`]="{ item }">
          <v-row justify="end" cols="12">
            <v-col justify="end" cols="8">
              <v-switch
                  inset
                  align="end"
                  v-model="item.recommendation"
                  @change="showModalRecommendation(item)"
              >
              </v-switch>
            </v-col>
          </v-row>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <section class="d-flex align-center">
            <v-btn
              outlined
              class="quinary-button ma-2 hidden-md-and-down"
              style="border-radius: 4px; width: 50px!important; height: 35px!important;"
              @click="goToProfile(item)"
            >
              Detalhar
            </v-btn>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px; height: 35px!important;"
                  small
                  class="quinary-button ma-1 edit-button hidden-sm-and-up"
                  color="quaternary"
                  @click="goToProfile(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-account-details</v-icon>
                </v-btn>
              </template>
              <span>Perfil</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px; height: 35px!important;"
                  small
                  class="quinary-button ma-1 edit-button"
                  color="quaternary"
                  @click="editInstaller(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px; height: 35px!important;"
                  small
                  class="ma-1 edit-button"
                  color="red"
                  @click="deleteInstaller(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </section>
        </template>

        <template v-slot:header.data-table-select="{ on, props}">
          <v-simple-checkbox
              color="#bc0000"
              v-bind="props"
              v-on="on"
              :ripple="false"
          >
          </v-simple-checkbox>
        </template>

        <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
          <v-simple-checkbox
              :ripple="false"
              @click="addInstallerListSelectedInstallers(item)"
              :value="isSelected"
              color="#bc0000"
              v-bind="props"
              v-on="on"
          >
          </v-simple-checkbox>
        </template>

        <template v-slot:footer >
          <section class="ma-0 pa-0">
            <Pagination
                v-if="totalItems > pageSize"
                :currentPage="currentPage"
                :totalItems="totalItems"
                :page="page"
                :pageSize="pageSize"
                :totalPages="totalPages"
                @back-page="backPage"
                @next-page="nextPage"
            >
            </Pagination>
          </section>

          <v-row cols="12" class="mx-0 mb-0 mt-1 " v-if="selectedInstallers.length > 0">
            <v-col cols="12" class="ma-0 pa-0 pa-0 mb-0 mt-2">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 pa-0 mb-0 mt-2">
              <label>Selecione a ação</label>
              <v-select
                  class="ma-0 pa-0 "
                  dense
                  v-model="actionSelected"
                  outlined
                  style="border-radius: 3px!important"
                  :items="actions"
                  item-text="label"
                  item-value="value"
                  placeholder="Selecione a ação"
              >
              </v-select>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 mt-2">
              <v-btn
                  class="secondary-button mt-5 ml-3"
                  style="height: 40px!important; border-radius: 7.5px!important"
                  height="40"
                  width="100%"
                  elevation="0"
                  :disabled="!actionSelected"
                  @click="confirmActionDialog = true"
              >
                {{ actionSelected ? actions.find((x) => x.value === actionSelected).label : 'Selecione a ação'}}
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-container>

    <!-- Importar Excel -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="importDialog"
      max-width="650px"
    >
      <ImportExcel
        title="Importar Aplicadores"
        textMessage="Importar arquivos '.xlsx' (Excel) para agilizar o processo de adição em massa!"
        icone="mdi-arrow-down-circle"
        tipo="Aplicadores"
        route="Users"
        typeRoute="aplicadores"
        @close="(importDialog = false), updateTable()"
        @generate="(importDialog = false), updateTable()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- Exportar Excel -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="excelDialog"
      max-width="500px"
    >
      <ExcelModal
        title="Exportar Aplicadores"
        textMessage="Deseja exportar os usuários para excel ?"
        cancelBtn="Cancelar"
        okbtn="Sim, baixar"
        icone="mdi-arrow-up-circle"
        textObservation=""
        @close="excelDialog = false"
        @generate="(excelDialog = false), generateExcel()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- Dialog DELETE  -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="deleteDialog"
      max-width="450px"
    >
      <DeleteModal
        title="Deletar"
        textMessage="Tem certeza que deseja excluir este revendedor?"
        cancelBtn="Cancelar"
        okbtn="Sim"
        textObservation=""
        icone="mdi-restore-alert"
        @close="(deleteDialog = false), updateTable()"
        @action="(deleteDialog = false), remove()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- ChangeStatus Dialog  -->
    <v-dialog v-model="changeDialog" max-width="450px">
      <AprovalModal
        :title="
          this.currentInstaller.status == 1
            ? 'Ativar Aplicador'
            : 'Inativar Aplicador'
        "
        :textMessage="aprovalConfirm"
        cancelBtn="Cancelar"
        :okbtn="this.currentInstaller.status == 1 ? 'ATIVAR' : 'INATIVAR'"
        textObservation=""
        icone="mdi-restore-alert"
        @close="(changeDialog = false), updateTable()"
        @action="(changeDialog = false), changeStatus()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- ChangeStatus Dialog  -->
    <v-dialog persistent v-model="changeDialogRecommendation" max-width="450px">
      <AprovalModal
        :title="
          currentInstaller.recommendation == 1
            ? 'Mostrar aplicador na loja'
            : 'Ocultar aplicador na loja'
        "
        :textMessage="aprovalConfirm"
        cancelBtn="Cancelar"
        :okbtn="currentInstaller.recommendation == 1 ? 'MOSTRAR' : 'OCULTAR'"
        textObservation=""
        icone="mdi-restore-alert"
        @close="(changeDialogRecommendation = false), updateTable()"
        @action="(changeDialogRecommendation = false), editRecommendation()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="confirmActionDialog" max-width="450">
      <ConfirmModal
          v-if="actionSelected"
          title=""
          textMessage=""
          :textObservation1="`Deseja realmente ${actions.find((x) => x.value === actionSelected).label} selecionados?`"
          textObservation2=""
          cancelBtn="Cancelar"
          okbtn="Sim"
          textObservation=""
          @close="(confirmActionDialog = false)"
          @action="performAction()"
      />
    </v-dialog>

    <v-dialog
        v-model="confirmActionRecordCannotDeleteModalDialog"
        max-width="700"
    >
      <RecordCannotDeleteModal
          :recordsCannotDelete="recordsCannotDelete"
          :title="titleRecordsCannotDelete"
          @close="(confirmActionRecordCannotDeleteModalDialog = false)"
      />
    </v-dialog>
  </div>
</template>

<style scoped>
.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}

.tab {
  font-weight: bold;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}
.main-card {
  background: #ffffff;
  box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1) !important;
  border-radius: 6px !important;
}

.v-toolbar__content {
  justify-content: center !important;
}

.actives {
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #bc0000;
}

.item {
  background: #424242 !important;
}

.item span {
  font-size: 1.05rem;
  color: #fff;
}

.back {
  background: #e9e9e9 !important;
  max-width: unset;
}

.filterAutocomplete {
  background: #f5f5f5;
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
}

.table-button {
  font-weight: bold;
  transition: 300ms;
}

.table-button:hover {
  background: #2d3038;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

@media (max-width: 900px) {
  .mytable {
    max-width: 100%;
  }
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import Utils from "../../../Utils/FormatDate";
import ExcelModal from "../components/ExcelModal.vue";
import ImportExcel from "../components/ImportExcel.vue";
import HeaderInstaller from "./components/HeaderInstaller.vue";
import AprovalModal from "../components/AprovalModal.vue";
import DeleteModal from "../components/DeleteModal.vue";
import router from "../../../router";
import Vue from "vue";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";
import RecordCannotDeleteModal from "@/views/pages/components/RecordCannotDeleteModal.vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  data: () => ({
    recordsCannotDelete: [],
    titleRecordsCannotDelete: "",
    confirmActionRecordCannotDeleteModalDialog: false,
    selectedInstallers: [],
    actions: [
      { label: "Ativar aplicador(s)", value: 1},
      { label: "Inativar aplicador(s)", value: 2},
      { label: "Excluir aplicador(s)", value: 3},
      { label: "Retirar indicação do aplicador(s)", value: 4},
      { label: "Adicinar indicação ao aplicador(s)", value: 5},
    ],
    actionSelected: null,
    confirmActionDialog: false,
    orders: ["Crescente", "Decrescente"],
    specialtiesArray: [],
    newInstallerDialog: false,
    countMaster: "",
    countInstallers: "",
    disableStatus: false,
    ativos: [],
    length: "",
    UserssId: "",
    showFilters: true,
    rating: "",
    dialog: false,
    closeNoLoading: false,
    addDialog: false,
    editDialog: false,
    aboutDialog: false,
    deleteDialog: false,
    importDialog: false,
    changeDialog: false,
    excelDialog: false,
    dialogKey: false,
    loading: false,
    isLoading: false,
    installers: [],
    currentInstaller: {},
    page: 1,
    totalPages: 1,
    totalItems: 1,
    currentPage: 1,
    pageSize: 10,
    btnColor: "",
    sizes: [10, 30, 90, 150],
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 10,
    },
    status: [
      { name: "Inativo", value: 0 },
      { name: "Ativo", value: 1 },
    ],
    error: false,
    show: false,
    changeDialogRecommendation: false,
    message: "",
    headers: [
      {
        text: "Nome",
        class: "item",
        sortable: false,
        align: "center",
        value: "name",
      },
      {
        text: "ID",
        class: "item",
        value: "id",
        sortable: false,
        align: "center",
      },
      {
        text: "Status",
        class: "item",
        value: "status",
        sortable: false,
        align: "center",
      },
      {
        text: "E-mail",
        class: "item",
        value: "email",
        sortable: false,
        align: "center",
      },
      {
        text: "Tipo",
        class: "item",
        value: "type",
        sortable: false,
        align: "center",
      },
      {
        text: "Ações",
        class: "item",
        align: "center",
        value: "actions",
        sortable: false,
      },
      {
        text: "Indicação",
        class: "item",
        value: "recommendation",
        sortable: false,
        align: "center",
      },
      {
        align: "center",
        sortable: false,
        value: "download",
      },
    ],
    solicitations: 0,
    aprovalConfirm: '',
    headerProps: {
      sortByText: "Ordenar por",
    },
  }),

  components: {
    RecordCannotDeleteModal,
    ConfirmModal,
    Pagination,
    HeaderInstaller,
    ImportExcel,
    ExcelModal,
    AprovalModal,
    DeleteModal,
  },

  computed: {

  },

  async created() {
    await this.updatePageView();
  },

  methods: {
    performAction(){
      this.confirmActionDialog = false;
      switch (this.actions.find((x) => x.value === this.actionSelected).label) {
        case 'Ativar aplicador(s)':
        case 'Inativar aplicador(s)':
          this.updateStatusInstallers()
          break
        case 'Retirar indicação do aplicador(s)':
        case 'Adicinar indicação ao aplicador(s)':
          this.updateRecommendationInstallers()
          break
        default:
          this.removeInstallers()
      }
    },

    updateStatusInstallers(){
      try {
        const selectedInstallers = JSON.parse(JSON.stringify(this.selectedInstallers))
        selectedInstallers.forEach((installer) => {
          installer.status = this.actionSelected === 1 ? 1 : 0;
        })

        this.apiService.put('installer/status/list', selectedInstallers).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Status dos aplicadores atualizados com sucesso.",
            trace: null,
          });
          await this.updateTable()
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível atualizar o status dos aplicadores",
            trace: null,
          });
        })
      } catch (e) {

      }
    },

    updateRecommendationInstallers(){
      try {
        const selectedInstallers = JSON.parse(JSON.stringify(this.selectedInstallers))
        selectedInstallers.forEach((installer) => {
          installer.recommendation = this.actionSelected === 5;
        })

        this.apiService.put('installer/recommendation/list', selectedInstallers).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Indicação dos aplicadores atualizadas com sucesso.",
            trace: null,
          });
          await this.updateTable()
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível atualizar a indicação dos aplicadores",
            trace: null,
          });
        })
      } catch (e) {

      }
    },

    removeInstallers(){
      try {
        this.recordsCannotDelete = [];
        this.confirmActionDialog = false;
        this.selectedInstallers.forEach((installer) => {
          const itens = []
          if (installer.orders && installer.orders.length > 0) {
            itens.push('Aplicador tem pedidos relacionada')
          }
          if (installer.adresses && installer.adresses.length > 0) {
            itens.push('Aplicador tem endereços relacionada')
          }
          if (installer.ordersReview && installer.ordersReview.length > 0) {
            itens.push('Aplicador tem avaliações de pedidos relacionada')
          }
          if (installer.productsReview && installer.productsReview.length > 0) {
            itens.push('Aplicador tem avaliações de produtos relacionada')
          }

          if (itens.length > 0){
            this.recordsCannotDelete.push(
                {
                  subTitle: `Aplicador: <strong>${installer.name}</strong>`,
                  motives: itens,
                }
            )
          }
        })

        if (this.recordsCannotDelete.length > 0) {
          this.confirmActionRecordCannotDeleteModalDialog = true
          this.confirmActionDialog = false
          this.titleRecordsCannotDelete = `Aplicadores que não podem serem excluídos`
          return
        }
        this.apiService.post('installer/delete/list', this.selectedInstallers).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Aplicadores excluídos com sucesso",
            trace: null,
          });
          await this.updateTable()
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível excluir ao aplicadores",
            trace: null,
          });
        })
      } catch (e) {

      }
    },

    addInstallerListSelectedInstallers(installer){
      const installerFind = this.selectedInstallers.findIndex((x) => x.id === installer.id)
      if (installerFind > -1) {
        this.selectedInstallers.splice(installerFind, 1)
      } else {
        this.selectedInstallers.push(installer)
      }
    },

    filterSolicita(arg) {
      this.page = 1;
      this.filter.page = this.page;
      if (arg == "Inativo") {
        this.disableStatus = true;
        this.filter.Status = 0;
      } else if (arg == "all") {
        this.disableStatus = false;
        this.filter.Status = null;
      }
      this.updateTable();
    },

    changeStatus(item) {
      item = this.approveSelectedItem;
      item.status = !item.status
      this.editStatus(item);
    },

    showModalRecommendation(item) {
      this.approveSelectedItem = item;
      this.currentInstaller = item;
      this.changeDialogRecommendation = true;
      this.aprovalConfirm =
          `Tem certeza que deseja ${
              this.currentInstaller.recommendation == 1 ? "mostrar" : "ocultar"
          } o aplicador ${this.currentInstaller.name} ?`;
    },

    async editStatus(item) {
      this.loading = true;
      this.currentInstaller = item;

      await this.apiService
        .post(`installer/changestatus`, this.currentInstaller)
        .then((resp) => {
          this.updatePageView();
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Mudança de status efetuada!",
            message: "Mudança de status efetuada!",
            trace: null,
          });
        })
        .catch((err) => {
          if (err.status != 403) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Não foi possível mudar a status do aplicador",
              message: "Confira se o e-mail já está cadastrado",
              trace: null,
            });
          } else if (err.status == 403) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Este usuário não tem autorização para concluir a ação.",
              message: "Somente usuários com permissão podem deletar/editar",
              trace: null,
            });
            this.$router.push("/resales");
            this.close();
          }

          this.loading = false;
        });
    },

    async editRecommendation(item) {
      this.loading = true;
      this.changeDialogRecommendation = false;
      await this.apiService
        .post(`installer/recommendation`, this.currentInstaller)
        .then((resp) => {
          this.updatePageView();
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Atualizado com sucesso!",
            trace: null,
          });
        })
        .catch((err) => {
          if (err.status != 403) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Não foi possível mudar a status do aplicador",
              message: "Confira se o e-mail já está cadastrado",
              trace: null,
            });
          } else if (err.status == 403) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Este usuário não tem autorização para concluir a ação.",
              message: "Somente usuários com permissão podem deletar/editar",
              trace: null,
            });
            this.$router.push("/resales");
            this.close();
          }

          this.loading = false;
        });
    },

    async goToProfile(item) {
      localStorage.setItem("installerFilters", JSON.stringify(this.filter));
      await this.$router.push({
        path: `/profile-installer?id=` + item.id + `&profile=` + item.name,
        params: item,
      });
    },

    async updatePageView() {
      this.filter.Status = null;

      const jsonFilters = localStorage.getItem("installerFilters");

      if (jsonFilters) {
        this.filter = JSON.parse(jsonFilters);
        this.page = this.filter.page;
      }

      await this.updateTable();
      await this.updateSpecialties();
      this.countInstallers = this.installers.filter(
        (installer) => installer.status == 1
      ).length;
    },

    async updateSpecialties() {
      this.loading = true;
      this.isLoading = true;
      await this.apiService
        .post(`specialties/list`, this.filter)
        .then((response) => {
          this.specialtiesArray = response.specialties;
          this.loading = false;
          this.isLoading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.close();
        });
    },

    async addInstaller() {
      this.currentInstaller = {};
      this.dialogKey = !this.dialogKey;

      await this.$router.push({
        path: "/add-installer",
      });
    },

    formatDate(date) {
      return Utils.moment(date);
    },

    parse_date(date) {
      var momentDate = moment(date);
      return (
        momentDate.format("DD") /
        momentDate.format("MM") /
        momentDate.format("YYYY")
      );
    },

    toggleChangeDialog(item) {
      this.approveSelectedItem = item;
      this.currentInstaller = item;
      this.dialogKey = !this.dialogKey;
      this.changeDialog = true;
      this.aprovalConfirm =
          `Tem certeza que deseja ${
              this.currentInstaller.status == 1 ? "ativar" : "inativar"
          } o aplicador ${this.currentInstaller.name} ?`;

    },

    async editInstaller(item) {
      localStorage.setItem("installerFilters", JSON.stringify(this.filter));

      await this.$router.push({
        path: "/add-installer?isEditing=true&id=" + item.id,
        params: item,
      });
    },

    deleteInstaller(item) {
      this.currentInstaller = item;
      this.dialogKey = !this.dialogKey;
      this.deleteDialog = true;
    },

    exportExcel(installers) {
      this.currentInstaller = this.installers;
      this.dialogKey = !this.dialogKey;
      this.excelDialog = true;
    },

    detailsUsers(item) {
      this.currentInstaller = item;
      this.dialogKey = !this.dialogKey;
      this.detailsDialog = true;
    },

    importExcel(user) {
      this.dialogKey = !this.dialogKey;
      this.importDialog = true;
    },

    closeDialog() {
      this.dialog = false;
      this.editDialog = false;
      this.deleteDialog = false;
      this.importDialog = false;
      this.detailsDialog = false;
      this.dialogKey = !this.dialogKey;
      this.updateTable();
    },

    openAbout(user) {
      this.currentInstaller = user;
      this.$router.push("/details-users");
    },

    filterTable() {
      this.loading = true;
      this.filter.pageSize = this.pageSize;
      this.filter.page = this.page;

      if (this.UsersInicialDate > this.UsersFinalDate) {
        this.error = true;
        this.reset();
        setTimeout(() => {
          this.error = false;
        }, 4000);
        return;
      }

      this.updateTable();
    },

    async updateTable() {
      this.loading = true;
      this.isLoading = true;
      await this.apiService
        .post(`installer/list`, this.filter)
        .then((response) => {
          this.installers = response.content.list.installers;
          this.solicitations = response.content.inactiveCount;
          this.totalPages = response.content.list.pager.totalPages;
          this.totalItems = response.content.list.pager.totalItems;
          this.currentPage = response.content.list.pager.currentPage;
          this.loading = false;
          this.isLoading = false;
        });
    },

    async backPage() {
      this.filter.page -= 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    async nextPage() {
      this.filter.page += 1;
      this.page = this.filter.page;
      await this.updateTable();
    },


    reset() {
      (this.filter = ""),
        (this.filter = {
          page: 1,
          pageSize: 10,
        });
      this.page = 1
      this.updateTable();
    },

    close() {
      this.$emit("close");
    },

    async remove() {
      this.loading = true;
      await this.apiService
        .delete(`installer/delete`, this.currentInstaller)
        .then((response) => {
          this.deleteDialog = false;
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Aplicador removido com sucesso.",
            message: "Aplicador removido com sucesso.",
            trace: null,
          });

          this.updateTable();
        })
        .catch((err) => {
          this.deleteDialog = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Não foi possível excluir este aplicador",
            message: err.body.message,
            trace: null,
          });
          this.$router.push("/installers");

          this.close();
          this.deleteDialog = false;
          this.loading = false;
        });

      this.loading = false;
    },

    async generateExcel() {
      this.loading = true;
      let now = new Date();
      var filename =
        `Aplicadores_` +
        `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}.xlsx`;

      await this.apiService
        .post("installer/excel", this.filter)
        .then((response) => {
          response = "data:application/octet-stream;base64," + response;
          const link = document.createElement("a");
          link.href = response;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
          // this.$emit("close");
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Não foi possível efetuar a exportação",
            message: erro.body.message,
            trace: null,
          });
        });
    },
  },

  watch: {},
};
</script>
